import { Link } from 'react-router-dom';

const LicensingSection = () => {
  const placements = [
    { icon: 'ri-film-line', text: 'Film + Television' },
    { icon: 'ri-megaphone-line', text: 'Commercial campaigns' },
    { icon: 'ri-play-circle-line', text: 'Streaming + digital media' },
    { icon: 'ri-gamepad-line', text: 'Video games + trailers' },
    { icon: 'ri-store-line', text: 'Heritage + lifestyle brands' },
  ];

  return (
    <section className="bg-leather-dark py-16 sm:py-32">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="font-display text-3xl sm:text-5xl md:text-6xl font-black text-cream mb-4 sm:mb-6 uppercase">
            Licensing Division
          </h2>
          <div className="w-16 sm:w-24 h-1 bg-orange-burnt mx-auto mb-6 sm:mb-8"></div>
          <p className="font-sans text-base sm:text-xl text-cream/90 max-w-3xl mx-auto leading-relaxed">
            Santos Music Group offers <strong className="font-semibold text-orange-burnt">one-stop clearance</strong> for authentic Texas-rooted recordings.
          </p>
        </div>

        {/* Placements Grid */}
        <div className="mb-10 sm:mb-16">
          <h3 className="font-western text-lg sm:text-2xl font-bold text-orange-burnt mb-6 sm:mb-8 text-center uppercase">
            Placements For:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {placements.map((item, index) => (
              <div
                key={index}
                className="bg-cream/5 border-2 border-cream/20 p-5 sm:p-8 flex items-center gap-3 sm:gap-4 hover:border-orange-burnt transition-all duration-300"
              >
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-orange-burnt/10 border-2 border-orange-burnt flex-shrink-0">
                  <i className={`${item.icon} text-xl sm:text-2xl text-orange-burnt`}></i>
                </div>
                <p className="font-sans text-sm sm:text-base text-cream font-medium">{item.text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <Link
            to="/contact"
            className="inline-block bg-orange-burnt text-cream px-8 sm:px-12 py-4 sm:py-5 rounded-none font-sans text-sm sm:text-base font-bold uppercase tracking-wider hover:bg-cream hover:text-leather-dark transition-all whitespace-nowrap cursor-pointer border-2 border-orange-burnt"
          >
            Request a Sync Pack
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LicensingSection;
